import myVideo from './myVideo'

export default myVideo;


// WEBPACK FOOTER //
// ./src/myComponents/myVideo/myVideo.js